<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>舟向索夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">索夹</div>
          <!-- <div class="sensor2">进气口</div> -->
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <!-- <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSN3, humidityAllowedMaxSN3) }}
              </div>
              <div :class="errorSN3" class="state-info right-pos" @dblclick="hrefToScenario('5b39453e-508f-4e0a-8a96-1fd1ebdb59c0')">
                <p>SN3传感器</p>
                <p>
                  <span
                    >{{ humiditySN3 | toFixed }}% {{ temperatureSN3 | toFixed }}°C <br />
                    {{ pressureSN3 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSN26, humidityAllowedMaxSN26) }}
              </div>
              <div :class="errorSN26" class="state-info right-pos" @dblclick="hrefToScenario('2e5e6211-a406-4c2e-b25e-fdb701dcc5e2')">
                <p>SN26传感器</p>
                <p>
                  <span
                    >{{ humiditySN26 | toFixed }}% {{ temperatureSN26 | toFixed }}°C <br />
                    {{ pressureSN26 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorS4, humidityAllowedMaxS4) }}
              </div>
              <div :class="errorS4" class="state-info left-pos" @dblclick="hrefToScenario('256a2c81-c045-4fe1-8831-9f38156e70ce')">
                <p>S4传感器</p>
                <p>
                  <span
                    >{{ humidityS4 | toFixed }}% {{ temperatureS4 | toFixed }}°C <br />
                    {{ pressureS4 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S39索夹", humidityTooltipErrorS39, humidityAllowedMaxS39) }} <br />
                {{ assembleTooltip_sensor("S40索夹", humidityTooltipErrorS40, humidityAllowedMaxS40) }}
              </div>
              <div :class="errorS39" class="state-info right-pos" @dblclick="hrefToScenario('36a01c28-c748-4a08-9705-c08067e9d980')">
                <p>S39 S40传感器</p>
                <p>
                  <!-- <span
                    >{{ humidityS39 | toFixed }}% {{ temperatureS39 | toFixed }}°C {{ pressureS39 | toFixed }}Pa <br />
                    {{ humidityS40 | toFixed }}% {{ temperatureS40 | toFixed }}°C {{ pressureS40 | toFixed }}Pa
                  </span> -->
                  <span
                    >{{ pressureS39 | toFixed }}Pa {{ temperatureS39 | toFixed }}°C {{ humidityS39 | toFixed }}% <br />
                    {{ pressureS40 | toFixed }}Pa {{ temperatureS40 | toFixed }}°C {{ humidityS40 | toFixed }}%
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S41索夹", humidityTooltipErrorS41, humidityAllowedMaxS41) }} <br />
                {{ assembleTooltip_sensor("S42索夹", humidityTooltipErrorS42, humidityAllowedMaxS42) }}
              </div>
              <div :class="errorS41" class="state-info right-pos" @dblclick="hrefToScenario('a76c167e-ad37-42ff-b7e1-813b8ab751f7')">
                <p>S41 S42传感器</p>
                <p>
                  <!-- <span
                    >{{ humidityS41 | toFixed }}% {{ temperatureS41 | toFixed }}°C {{ pressureS41 | toFixed }}Pa <br />
                    {{ humidityS42 | toFixed }}% {{ temperatureS42 | toFixed }}°C {{ pressureS42 | toFixed }}Pa
                  </span> -->
                  <span
                    >{{ pressureS41 | toFixed }}Pa {{ temperatureS41 | toFixed }}°C {{ humidityS41 | toFixed }}% <br />
                    {{ pressureS42 | toFixed }}Pa {{ temperatureS42 | toFixed }}°C {{ humidityS42 | toFixed }}%
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S43索夹", humidityTooltipErrorS43, humidityAllowedMaxS43) }} <br />
                {{ assembleTooltip_sensor("S44索夹", humidityTooltipErrorS44, humidityAllowedMaxS44) }}
              </div>
              <div :class="errorS43" class="state-info bottom-pos" @dblclick="hrefToScenario('383bae59-9376-446a-a7a1-243dac380b0c')">
                <p>S43 S44传感器</p>
                <p>
                  <span
                    >{{ humidityS43 | toFixed }}% {{ temperatureS43 | toFixed }}°C {{ pressureS43 | toFixed }}Pa <br />
                    {{ humidityS44 | toFixed }}% {{ temperatureS44 | toFixed }}°C {{ pressureS44 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S45索夹", humidityTooltipErrorS45, humidityAllowedMaxS45) }} <br />
                {{ assembleTooltip_sensor("S46索夹", humidityTooltipErrorS46, humidityAllowedMaxS46) }}
              </div>
              <div :class="errorS45" class="state-info top-pos" @dblclick="hrefToScenario('a5d633a6-5746-4946-975a-675d68e5258b')">
                <p>S45 S46传感器</p>
                <p>
                  <span
                    >{{ humidityS45 | toFixed }}% {{ temperatureS45 | toFixed }}°C {{ pressureS45 | toFixed }}Pa <br />
                    {{ humidityS46 | toFixed }}% {{ temperatureS46 | toFixed }}°C {{ pressureS46 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S47索夹", humidityTooltipErrorS47, humidityAllowedMaxS47) }} <br />
                {{ assembleTooltip_sensor("S48索夹", humidityTooltipErrorS48, humidityAllowedMaxS48) }}
              </div>
              <div :class="errorS47" class="state-info left-pos" @dblclick="hrefToScenario('1b34c442-3804-4405-9fb3-9bc3693a84b0')">
                <p>S47 S48传感器</p>
                <p>
                  <span
                    >{{ humidityS47 | toFixed }}% {{ temperatureS47 | toFixed }}°C {{ pressureS47 | toFixed }}Pa <br />
                    {{ humidityS48 | toFixed }}% {{ temperatureS48 | toFixed }}°C {{ pressureS48 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("S49索夹", humidityTooltipErrorS49, humidityAllowedMaxS49) }} <br />
                {{ assembleTooltip_sensor("S50索夹", humidityTooltipErrorS50, humidityAllowedMaxS50) }}
              </div>
              <div :class="errorS49" class="state-info left-pos" @dblclick="hrefToScenario('da5bb60e-d28f-4d51-907f-336f21b1d197')">
                <p>S49 S50传感器</p>
                <p>
                  <span
                    >{{ humidityS49 | toFixed }}% {{ temperatureS49 | toFixed }}°C {{ pressureS49 | toFixed }}Pa <br />
                    {{ humidityS50 | toFixed }}% {{ temperatureS50 | toFixed }}°C {{ pressureS50 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorS86, humidityAllowedMaxS86) }}
              </div>
              <div :class="errorS86" class="state-info right-pos" @dblclick="hrefToScenario('990034a7-0e76-44f5-ad8f-1277968b8ded')">
                <p>S86传感器</p>
                <p>
                  <span
                    >{{ humidityS86 | toFixed }}% {{ temperatureS86 | toFixed }}°C <br />
                    {{ pressureS86 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSS21, humidityAllowedMaxSS21) }}
              </div>
              <div :class="errorSS21" class="state-info left-pos" @dblclick="hrefToScenario('8555a384-6c07-40dc-9de4-1bc039d50176')">
                <p>SS21传感器</p>
                <p>
                  <span
                    >{{ humiditySS21 | toFixed }}% {{ temperatureSS21 | toFixed }}°C <br />
                    {{ pressureSS21 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorSS3, humidityAllowedMaxSS3) }}
              </div>
              <div :class="errorSS3" class="state-info left-pos" @dblclick="hrefToScenario('2dd6e23c-0cfa-442d-843c-992ca6773745')">
                <p>SS3传感器</p>
                <p>
                  <span
                    >{{ humiditySS3 | toFixed }}% {{ temperatureSS3 | toFixed }}°C <br />
                    {{ pressureSS3 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>宁向索夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">索夹</div>
          <!-- <div class="sensor2">进气口</div> -->
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <!-- <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <div class="clip sensor1 sensor-left-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXN3, humidityAllowedMaxXN3) }}
              </div>
              <div :class="errorXN3" class="state-info right-pos" @dblclick="hrefToScenario('0fde62f3-9025-4485-afba-95cb6f6d6779')">
                <p>XN3传感器</p>
                <p>
                  <span
                    >{{ humidityXN3 | toFixed }}% {{ temperatureXN3 | toFixed }}°C <br />
                    {{ pressureXN3 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-left-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXN26, humidityAllowedMaxXN26) }}
              </div>
              <div :class="errorXN26" class="state-info right-pos" @dblclick="hrefToScenario('7b9e0104-ef16-4fb5-88d6-a6fcc6352324')">
                <p>XN26传感器</p>
                <p>
                  <span
                    >{{ humidityXN26 | toFixed }}% {{ temperatureXN26 | toFixed }}°C <br />
                    {{ pressureXN26 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorX4, humidityAllowedMaxX4) }}
              </div>
              <div :class="errorX4" class="state-info left-pos" @dblclick="hrefToScenario('e1ee3155-dbe0-4f02-9c96-1357b9be5789')">
                <p>X4传感器</p>
                <p>
                  <span
                    >{{ humidityX4 | toFixed }}% {{ temperatureX4 | toFixed }}°C <br />
                    {{ pressureX4 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X39索夹", humidityTooltipErrorX39, humidityAllowedMaxX39) }} <br />
                {{ assembleTooltip_sensor("X40索夹", humidityTooltipErrorX40, humidityAllowedMaxX40) }}
              </div>
              <div :class="errorX39" class="state-info right-pos" @dblclick="hrefToScenario('bfae7dbf-ed21-42f2-a3a5-52e8f7737ca6')">
                <p>X39 X40传感器</p>
                <p>
                  <!-- <span
                    >{{ humidityX39 | toFixed }}% {{ temperatureX39 | toFixed }}°C {{ pressureX39 | toFixed }}Pa <br />
                    {{ humidityX40 | toFixed }}% {{ temperatureX40 | toFixed }}°C {{ pressureX40 | toFixed }}Pa
                  </span> -->
                  <span
                    >{{ pressureX39 | toFixed }}Pa {{ temperatureX39 | toFixed }}°C {{ humidityX39 | toFixed }}% <br />
                    {{ pressureX40 | toFixed }}Pa {{ temperatureX40 | toFixed }}°C {{ humidityX40 | toFixed }}%
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X41索夹", humidityTooltipErrorX41, humidityAllowedMaxX41) }} <br />
                {{ assembleTooltip_sensor("X42索夹", humidityTooltipErrorX42, humidityAllowedMaxX42) }}
              </div>
              <div :class="errorX41" class="state-info right-pos" @dblclick="hrefToScenario('b5dbe949-84e5-4346-bf24-d6aa15f25a5d')">
                <p>X41 X42传感器</p>
                <p>
                  <!-- <span
                    >{{ humidityX41 | toFixed }}% {{ temperatureX41 | toFixed }}°C {{ pressureX41 | toFixed }}Pa <br />
                    {{ humidityX42 | toFixed }}% {{ temperatureX42 | toFixed }}°C {{ pressureX42 | toFixed }}Pa
                  </span> -->
                  <span
                    >{{ pressureX41 | toFixed }}Pa {{ temperatureX41 | toFixed }}°C {{ humidityX41 | toFixed }}% <br />
                    {{ pressureX42 | toFixed }}Pa {{ temperatureX42 | toFixed }}°C {{ humidityX42 | toFixed }}%
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X43索夹", humidityTooltipErrorX43, humidityAllowedMaxX43) }} <br />
                {{ assembleTooltip_sensor("X44索夹", humidityTooltipErrorX44, humidityAllowedMaxX44) }}
              </div>
              <div :class="errorX43" class="state-info bottom-pos" @dblclick="hrefToScenario('8de56c52-1181-4314-b8ff-cf5b535f4197')">
                <p>X43 X44传感器</p>
                <p>
                  <span
                    >{{ humidityX43 | toFixed }}% {{ temperatureX43 | toFixed }}°C {{ pressureX43 | toFixed }}Pa <br />
                    {{ humidityX44 | toFixed }}% {{ temperatureX44 | toFixed }}°C {{ pressureX44 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X45索夹", humidityTooltipErrorX45, humidityAllowedMaxX45) }} <br />
                {{ assembleTooltip_sensor("X46索夹", humidityTooltipErrorX46, humidityAllowedMaxX46) }}
              </div>
              <div :class="errorX45" class="state-info top-pos" @dblclick="hrefToScenario('32e88929-c1f0-4cd5-b93a-37611629e246')">
                <p>X45 X46传感器</p>
                <p>
                  <span
                    >{{ humidityX45 | toFixed }}% {{ temperatureX45 | toFixed }}°C {{ pressureX45 | toFixed }}Pa <br />
                    {{ humidityX46 | toFixed }}% {{ temperatureX46 | toFixed }}°C {{ pressureX46 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X47索夹", humidityTooltipErrorX47, humidityAllowedMaxX47) }} <br />
                {{ assembleTooltip_sensor("X48索夹", humidityTooltipErrorX48, humidityAllowedMaxX48) }}
              </div>
              <div :class="errorX47" class="state-info left-pos" @dblclick="hrefToScenario('0c53e97d-1cee-4241-b8d8-dcdd4859d4b7')">
                <p>X47 X48传感器</p>
                <p>
                  <span
                    >{{ humidityX47 | toFixed }}% {{ temperatureX47 | toFixed }}°C {{ pressureX47 | toFixed }}Pa <br />
                    {{ humidityX48 | toFixed }}% {{ temperatureX48 | toFixed }}°C {{ pressureX48 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("X49索夹", humidityTooltipErrorX49, humidityAllowedMaxX49) }} <br />
                {{ assembleTooltip_sensor("X50索夹", humidityTooltipErrorX50, humidityAllowedMaxX50) }}
              </div>
              <div :class="errorX49" class="state-info left-pos" @dblclick="hrefToScenario('67de6195-bcc5-4874-93e8-ccf23a33216c')">
                <p>X49 X50传感器</p>
                <p>
                  <span
                    >{{ humidityX49 | toFixed }}% {{ temperatureX49 | toFixed }}°C {{ pressureX49 | toFixed }}Pa <br />
                    {{ humidityX50 | toFixed }}% {{ temperatureX50 | toFixed }}°C {{ pressureX50 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-middle-8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorX86, humidityAllowedMaxX86) }}
              </div>
              <div :class="errorX86" class="state-info right-pos" @dblclick="hrefToScenario('a2e435c5-1a37-49a9-be74-b0064a949b3f')">
                <p>X86传感器</p>
                <p>
                  <span
                    >{{ humidityX86 | toFixed }}% {{ temperatureX86 | toFixed }}°C <br />
                    {{ pressureX86 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXS21, humidityAllowedMaxXS21) }}
              </div>
              <div :class="errorXS21" class="state-info left-pos" @dblclick="hrefToScenario('0ca4a631-50de-4518-806b-d08a85bd29e1')">
                <p>XS21传感器</p>
                <p>
                  <span
                    >{{ humidityXS21 | toFixed }}% {{ temperatureXS21 | toFixed }}°C <br />
                    {{ pressureXS21 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-right-1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXS3, humidityAllowedMaxXS3) }}
              </div>
              <div :class="errorXS3" class="state-info left-pos" @dblclick="hrefToScenario('e453f8d7-9e1b-49e2-b6ea-f81538142af4')">
                <p>XS3传感器</p>
                <p>
                  <span
                    >{{ humidityXS3 | toFixed }}% {{ temperatureXS3 | toFixed }}°C <br />
                    {{ pressureXS3 | toFixed }}Pa
                  </span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
      
      <script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "xihoumenSensor",
      bridgeId: "3aeeb5b1-f586-43c4-b03c-2e5880d2e541",

      //humidity, temperature
      humiditySN3: "--",
      humiditySN26: "--",
      humidityS4: "--",
      humidityS39: "--",
      humidityS40: "--",
      humidityS41: "--",
      humidityS42: "--",
      humidityS43: "--",
      humidityS44: "--",
      humidityS45: "--",
      humidityS46: "--",
      humidityS47: "--",
      humidityS48: "--",
      humidityS49: "--",
      humidityS50: "--",
      humidityS86: "--",
      humiditySS3: "--",
      humiditySS21: "--",
      humidityXN3: "--",
      humidityXN26: "--",
      humidityX4: "--",
      humidityX39: "--",
      humidityX40: "--",
      humidityX41: "--",
      humidityX42: "--",
      humidityX43: "--",
      humidityX44: "--",
      humidityX45: "--",
      humidityX46: "--",
      humidityX47: "--",
      humidityX48: "--",
      humidityX49: "--",
      humidityX50: "--",
      humidityX86: "--",
      humidityXS21: "--",
      humidityXS3: "--",
      humidityDehumidifierLeft: "--",
      humidityDehumidifierRight: "--",

      temperatureSN3: "--",
      temperatureSN26: "--",
      temperatureS4: "--",
      temperatureS39: "--",
      temperatureS40: "--",
      temperatureS41: "--",
      temperatureS42: "--",
      temperatureS43: "--",
      temperatureS44: "--",
      temperatureS45: "--",
      temperatureS46: "--",
      temperatureS47: "--",
      temperatureS48: "--",
      temperatureS49: "--",
      temperatureS50: "--",
      temperatureS86: "--",
      temperatureSS3: "--",
      temperatureSS21: "--",
      temperatureXN3: "--",
      temperatureXN26: "--",
      temperatureX4: "--",
      temperatureX39: "--",
      temperatureX40: "--",
      temperatureX41: "--",
      temperatureX42: "--",
      temperatureX43: "--",
      temperatureX44: "--",
      temperatureX45: "--",
      temperatureX46: "--",
      temperatureX47: "--",
      temperatureX48: "--",
      temperatureX49: "--",
      temperatureX50: "--",
      temperatureX86: "--",
      temperatureXS21: "--",
      temperatureXS3: "--",
      temperatureDehumidifierLeft: "--",
      temperatureDehumidifierRight: "--",

      pressureSN3: "--",
      pressureSN26: "--",
      pressureS4: "--",
      pressureS39: "--",
      pressureS40: "--",
      pressureS41: "--",
      pressureS42: "--",
      pressureS43: "--",
      pressureS44: "--",
      pressureS45: "--",
      pressureS46: "--",
      pressureS47: "--",
      pressureS48: "--",
      pressureS49: "--",
      pressureS50: "--",
      pressureS86: "--",
      pressureSS3: "--",
      pressureSS21: "--",
      pressureXN3: "--",
      pressureXN26: "--",
      pressureX4: "--",
      pressureX39: "--",
      pressureX40: "--",
      pressureX41: "--",
      pressureX42: "--",
      pressureX43: "--",
      pressureX44: "--",
      pressureX45: "--",
      pressureX46: "--",
      pressureX47: "--",
      pressureX48: "--",
      pressureX49: "--",
      pressureX50: "--",
      pressureX86: "--",
      pressureXS21: "--",
      pressureXS3: "--",

      //running
      runningDehumidifierLeft: "--",
      runningDehumidifierRight: "--",

      //malfunction
      malfunctionDehumidifierLeft: "--",
      malfunctionDehumidifierRight: "--",

      //error
      errorSN3: "--",
      errorSN26: "--",
      errorS4: "--",
      errorS39: "--",
      errorS40: "--",
      errorS41: "--",
      errorS42: "--",
      errorS43: "--",
      errorS44: "--",
      errorS45: "--",
      errorS46: "--",
      errorS47: "--",
      errorS48: "--",
      errorS49: "--",
      errorS50: "--",
      errorS86: "--",
      errorSS3: "--",
      errorSS21: "--",
      errorXN3: "--",
      errorXN26: "--",
      errorX4: "--",
      errorX39: "--",
      errorX40: "--",
      errorX41: "--",
      errorX42: "--",
      errorX43: "--",
      errorX44: "--",
      errorX45: "--",
      errorX46: "--",
      errorX47: "--",
      errorX48: "--",
      errorX49: "--",
      errorX50: "--",
      errorX86: "--",
      errorXS21: "--",
      errorXS3: "--",
      errorDehumidifierLeft: "--",
      errorDehumidifierRight: "--",

      //running class
      runningClassLeft: "--",
      runningClassRight: "--",

      //humidity allowed max
      humidityAllowedMaxSN3: "--",
      humidityAllowedMaxSN26: "--",
      humidityAllowedMaxS4: "--",
      humidityAllowedMaxS39: "--",
      humidityAllowedMaxS40: "--",
      humidityAllowedMaxS41: "--",
      humidityAllowedMaxS42: "--",
      humidityAllowedMaxS43: "--",
      humidityAllowedMaxS44: "--",
      humidityAllowedMaxS45: "--",
      humidityAllowedMaxS46: "--",
      humidityAllowedMaxS47: "--",
      humidityAllowedMaxS48: "--",
      humidityAllowedMaxS49: "--",
      humidityAllowedMaxS50: "--",
      humidityAllowedMaxS86: "--",
      humidityAllowedMaxSS3: "--",
      humidityAllowedMaxSS21: "--",
      humidityAllowedMaxXN3: "--",
      humidityAllowedMaxXN26: "--",
      humidityAllowedMaxX4: "--",
      humidityAllowedMaxX39: "--",
      humidityAllowedMaxX40: "--",
      humidityAllowedMaxX41: "--",
      humidityAllowedMaxX42: "--",
      humidityAllowedMaxX43: "--",
      humidityAllowedMaxX44: "--",
      humidityAllowedMaxX45: "--",
      humidityAllowedMaxX46: "--",
      humidityAllowedMaxX47: "--",
      humidityAllowedMaxX48: "--",
      humidityAllowedMaxX49: "--",
      humidityAllowedMaxX50: "--",
      humidityAllowedMaxX86: "--",
      humidityAllowedMaxXS21: "--",
      humidityAllowedMaxXS3: "--",
      humidityAllowedMaxDehumidifierLeft: "--",
      humidityAllowedMaxDehumidifierRight: "--",

      //humidity tooltip error
      humidityTooltipErrorSN3: "--",
      humidityTooltipErrorSN26: "--",
      humidityTooltipErrorS4: "--",
      humidityTooltipErrorS39: "--",
      humidityTooltipErrorS40: "--",
      humidityTooltipErrorS41: "--",
      humidityTooltipErrorS42: "--",
      humidityTooltipErrorS43: "--",
      humidityTooltipErrorS44: "--",
      humidityTooltipErrorS45: "--",
      humidityTooltipErrorS46: "--",
      humidityTooltipErrorS47: "--",
      humidityTooltipErrorS48: "--",
      humidityTooltipErrorS49: "--",
      humidityTooltipErrorS50: "--",
      humidityTooltipErrorS86: "--",
      humidityTooltipErrorSS3: "--",
      humidityTooltipErrorSS21: "--",
      humidityTooltipErrorXN3: "--",
      humidityTooltipErrorXN26: "--",
      humidityTooltipErrorX4: "--",
      humidityTooltipErrorX39: "--",
      humidityTooltipErrorX40: "--",
      humidityTooltipErrorX41: "--",
      humidityTooltipErrorX42: "--",
      humidityTooltipErrorX43: "--",
      humidityTooltipErrorX44: "--",
      humidityTooltipErrorX45: "--",
      humidityTooltipErrorX46: "--",
      humidityTooltipErrorX47: "--",
      humidityTooltipErrorX48: "--",
      humidityTooltipErrorX49: "--",
      humidityTooltipErrorX50: "--",
      humidityTooltipErrorX86: "--",
      humidityTooltipErrorXS21: "--",
      humidityTooltipErrorXS3: "--",
      humidityTooltipErrorDehumidifierLeft: "--",
      humidityTooltipErrorDehumidifierRight: "--",

      dataNameIdDict: {
        //humidity, temperature
        humiditySN3: "1380fd63-9747-4a65-b225-aafbbedd88de",
        humidityXN3: "adec26dd-afea-4654-a6db-0ffa8ea29285",
        humiditySN26: "2a2f4978-f7b1-41d9-80ab-5988c943361f",
        humidityXN26: "214b779a-e39e-4069-a75a-2c8d2232d790",
        humidityS4: "69ed9c73-c74e-4f1c-9d69-5ad55eda60f6",
        humidityX4: "a71ebf7c-0b06-4fde-a5dc-905fa430287d",
        humidityS39: "7f28b287-0103-4f8b-b49c-324b3895afaa",
        humidityX39: "e1793ad2-d2fc-4536-8934-e5529b579b46",
        humidityS40: "d66afbe1-a6b4-48f6-b620-a5ca7b29b789",
        humidityX40: "64a89945-0715-4e93-a1e5-e9ce3ec53d53",
        humidityS41: "3e84e499-cf43-4809-a455-617474e72d4c",
        humidityX41: "3519d68d-c7cc-46a4-b509-cdbf6405c244",
        humidityS42: "8b2e1e74-7a76-45b6-b3a7-e7d4345dba82",
        humidityX42: "1d554c0b-9f10-476e-b211-86a9fe106e08",
        humidityS43: "7ff48034-3a65-4c81-97f1-131bd6ceccae",
        humidityX43: "15f11193-7a0e-4e15-99b2-5b247a0b8c8d",
        humidityS44: "e6978fa0-52ce-436d-9959-09c90c71d3ed",
        humidityX44: "eaef1bcf-4ee2-4e9e-801f-99165d4689bf",
        humiditySS3: "b7253107-dee0-4ca3-9912-a63aaae2b908",
        humidityXS3: "140399df-e57f-4b8b-9bff-11f051dfe999",
        humiditySS21: "39672abf-5616-4ab7-af1b-9036a6c5dfdd",
        humidityXS21: "77edef1c-cecb-4ec5-ae18-c28cf51dae78",
        humidityS86: "a4a7382d-b92a-43a7-a317-d7b4db4250e5",
        humidityX86: "86869c41-89a5-4bf9-aaf4-3ff7d326520e",
        humidityS49: "968f29e7-7f29-4da6-bd16-9f397f93d6ed",
        humidityX49: "627eb18f-5d37-4a54-9102-534776dd2cda",
        humidityS50: "114e5ad7-02dd-42dd-a371-5cc1000d07bd",
        humidityX50: "e47200de-2eaa-4f03-9fd9-f1e23da84b32",
        humidityS47: "cc45460b-5444-4296-b519-6f507ad27f72",
        humidityX47: "2ced51d4-05c6-465d-a4fc-8da3182eaabb",
        humidityS48: "dd355335-e3e9-4bab-a8b1-3978f43ce657",
        humidityX48: "efa451c2-949b-4d64-8674-0a2c29e4fa6c",
        humidityS45: "e56702cc-7fa5-42f7-9e6c-41115033bf20",
        humidityX45: "12cc735c-3b98-4857-bea2-0706413b9c93",
        humidityS46: "da290182-d6d4-4e35-9d6e-940905ffbb5f",
        humidityX46: "1adc2e07-6869-42f4-b6db-54fe27c99349",
        humidityDehumidifierLeft: "42e9d3e0-e6bb-4e99-a70a-84807a10db8b",
        humidityDehumidifierRight: "7d31a969-65dd-4d8d-8466-6258bd6d97d5",

        temperatureSN3: "e645c6f0-7d9d-4a95-942f-d3c860053c55",
        temperatureXN3: "b4962db4-5f09-446a-b445-e94874843ec6",
        temperatureSN26: "c441b208-8d08-4772-ae65-0dd540893d94",
        temperatureXN26: "b1fe6719-88be-43e1-bc6e-113189f2bd5f",
        temperatureS4: "5c0f7647-8b5b-4506-b96e-4e0b6aa7d96f",
        temperatureX4: "43fa703d-4224-44ce-b952-282b43c0e37b",
        temperatureS39: "a1df7db1-4fad-47e0-8602-1803fb43a275",
        temperatureX39: "78d125c7-bf36-4dca-9c58-0b6b2cc6223b",
        temperatureS40: "66745776-75ce-473f-963a-a0a0627867ff",
        temperatureX40: "d15f18dc-73fa-417a-b1ee-23ba0ab7af78",
        temperatureS41: "cf2cea6e-e0df-496c-90aa-a13c108a3e7d",
        temperatureX41: "e0118a1f-a355-4728-ad0a-39e816130b53",
        temperatureS42: "c46eaf75-0a6f-4a71-92d8-e05970e290e7",
        temperatureX42: "37b9df88-bfd0-452f-bf9c-ad5980c6a21f",
        temperatureS43: "2caa78e8-7c1a-49c2-b93e-fe7327b28778",
        temperatureX43: "2029f967-18ff-4326-b4b6-0aedc8d73203",
        temperatureS44: "4b4e9b18-fdb1-49af-8763-ea9612267d9b",
        temperatureX44: "bec0cf32-bf7b-4e8c-94a0-9f907fd516b3",
        temperatureSS3: "ce8b81ff-6052-431b-b10c-6653b08f3153",
        temperatureXS3: "3ae51b1c-db86-4e98-9956-7839ad44ecf2",
        temperatureSS21: "c9f8a89e-198e-45e2-86de-5734cb3c7bf0",
        temperatureXS21: "06b5eaf4-65b2-4a57-8db7-5ed498c1567e",
        temperatureS86: "2ae5c158-17e5-4c77-aee1-315477b6ceb2",
        temperatureX86: "a5736d69-f1fc-4d0f-affd-2fe9b36eebfb",
        temperatureS49: "17026fb8-cb41-442a-bb90-1738f27df68e",
        temperatureX49: "b3e1bc04-169f-469f-adda-b1f746bcc7cf",
        temperatureS50: "4d1833b1-1658-494d-8d4c-a67a22f1776b",
        temperatureX50: "43d2e441-7d0c-4cd7-b683-6a92164de113",
        temperatureS47: "ffe5b7ec-ee5c-4d13-b10e-5e9d8ca2db75",
        temperatureX47: "652cd724-bd0b-4e96-8272-a3c03a70b04b",
        temperatureS48: "2c6e3f06-0095-4ac5-afda-d5818ea5d320",
        temperatureX48: "bba1bc72-b697-463b-a316-d3a0d4479cc6",
        temperatureS45: "92e8b1f2-67e9-4dac-a380-28312cddae5f",
        temperatureX45: "511fa662-fead-4649-b85c-8f042f1aa42b",
        temperatureS46: "524b1e55-faef-4987-ae41-295270baf81c",
        temperatureX46: "89774df3-0544-4419-bc67-21cbbae93b7f",
        temperatureDehumidifierLeft: "d08e8b75-6040-4405-9273-c66741a556ef",
        temperatureDehumidifierRight: "582b8de3-feb6-46e8-b38b-5f1cf7382b99",

        pressureSN3: "fd64e27b-df57-44ab-83ee-bb63f8de5927",
        pressureXN3: "8bc4b0cc-75e4-422a-9e48-9adf4c5b83db",
        pressureSN26: "29798d9b-8431-4fbe-b5e9-ef4cced5070b",
        pressureXN26: "aa835005-67c1-442e-b713-c80ba541d52e",
        pressureS4: "a20c9493-630d-4809-9a2e-02fc9d4b8984",
        pressureX4: "24f00a1f-fe76-403d-919c-c1db15639b87",
        pressureS39: "3ec0f777-8f6a-474f-bc88-0df87d5546e9",
        pressureX39: "aa549db1-ff88-4e74-8735-fb9470515c9b",
        pressureS40: "fee83013-0165-4c62-a34f-97ad986e3545",
        pressureX40: "a65b2c65-ae0e-47d8-81db-16f300f1aad4",
        pressureS41: "ae3d7d15-15c5-4947-81e1-7b70bf0d2a7d",
        pressureX41: "f4392eee-f7f9-49c8-bd98-e1cd9706d884",
        pressureS42: "b9def59d-5432-4900-b51a-bb035148d5bd",
        pressureX42: "5d5a95b8-60c5-41d1-baff-2e22851e0207",
        pressureS43: "4ac2069c-34ef-4de9-8016-be42c82e9e90",
        pressureX43: "c1aaa5ef-ca22-43b9-8467-1313eb821201",
        pressureS44: "e1e90037-47cd-4120-8867-edb5b049f85a",
        pressureX44: "48675e72-8bbf-4a6b-ad48-33cdb90be927",
        pressureSS3: "de5a62cf-11a9-4c46-862e-97c70668ebbb",
        pressureXS3: "7de242f3-1e36-458a-b77a-62a0862fa4d1",
        pressureSS21: "d5547f0e-449e-4d3b-a05b-9ca7c4fcb2d1",
        pressureXS21: "225a0791-27da-4ba6-8d0f-7cd17dcb0948",
        pressureS86: "6f0d1184-0439-4148-be80-6a85799171f9",
        pressureX86: "45f77cff-e624-4c54-b233-aa329f182454",
        pressureS49: "f0ccb82d-5b0a-4de2-ac83-5e89e4c0ae8a",
        pressureX49: "d10a52c0-5387-4450-9dbd-4d272dedaccd",
        pressureS50: "417de156-7767-4ae5-b0ce-d98869bea41c",
        pressureX50: "598d9224-408b-49b5-84e4-506dbf1f806a",
        pressureS47: "74889dca-392d-4080-8c51-b87dbc8de6de",
        pressureX47: "bfb9e6b1-55ed-42a9-82b6-7c4a014927f9",
        pressureS48: "88dfb6f9-72ab-416f-aeb3-411fc1494219",
        pressureX48: "677eb047-e184-43e8-9a6a-77b22e0a1ada",
        pressureS45: "a164875a-1df5-4267-b0a4-c8d877c537e1",
        pressureX45: "08831358-b538-4d9d-b382-d5cf70fa2d28",
        pressureS46: "b3482406-81b1-42dc-adaf-d0f7345db56c",
        pressureX46: "82250569-75bb-4ebe-bcbe-757e526cd535",

        //running
        runningDehumidifierLeft: "GUID",
        runningDehumidifierRight: "GUID",

        //malfunction
        malfunctionDehumidifierLeft: "GUID",
        malfunctionDehumidifierRight: "GUID",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxSN3: "1380fd63-9747-4a65-b225-aafbbedd88de",
        humidityAllowedMaxXN3: "adec26dd-afea-4654-a6db-0ffa8ea29285",
        humidityAllowedMaxSN26: "2a2f4978-f7b1-41d9-80ab-5988c943361f",
        humidityAllowedMaxXN26: "214b779a-e39e-4069-a75a-2c8d2232d790",
        humidityAllowedMaxS4: "69ed9c73-c74e-4f1c-9d69-5ad55eda60f6",
        humidityAllowedMaxX4: "a71ebf7c-0b06-4fde-a5dc-905fa430287d",
        humidityAllowedMaxS39: "7f28b287-0103-4f8b-b49c-324b3895afaa",
        humidityAllowedMaxX39: "e1793ad2-d2fc-4536-8934-e5529b579b46",
        humidityAllowedMaxS40: "d66afbe1-a6b4-48f6-b620-a5ca7b29b789",
        humidityAllowedMaxX40: "64a89945-0715-4e93-a1e5-e9ce3ec53d53",
        humidityAllowedMaxS41: "3e84e499-cf43-4809-a455-617474e72d4c",
        humidityAllowedMaxX41: "3519d68d-c7cc-46a4-b509-cdbf6405c244",
        humidityAllowedMaxS42: "8b2e1e74-7a76-45b6-b3a7-e7d4345dba82",
        humidityAllowedMaxX42: "1d554c0b-9f10-476e-b211-86a9fe106e08",
        humidityAllowedMaxS43: "7ff48034-3a65-4c81-97f1-131bd6ceccae",
        humidityAllowedMaxX43: "15f11193-7a0e-4e15-99b2-5b247a0b8c8d",
        humidityAllowedMaxS44: "e6978fa0-52ce-436d-9959-09c90c71d3ed",
        humidityAllowedMaxX44: "eaef1bcf-4ee2-4e9e-801f-99165d4689bf",
        humidityAllowedMaxSS3: "b7253107-dee0-4ca3-9912-a63aaae2b908",
        humidityAllowedMaxXS3: "140399df-e57f-4b8b-9bff-11f051dfe999",
        humidityAllowedMaxSS21: "39672abf-5616-4ab7-af1b-9036a6c5dfdd",
        humidityAllowedMaxXS21: "77edef1c-cecb-4ec5-ae18-c28cf51dae78",
        humidityAllowedMaxS86: "a4a7382d-b92a-43a7-a317-d7b4db4250e5",
        humidityAllowedMaxX86: "86869c41-89a5-4bf9-aaf4-3ff7d326520e",
        humidityAllowedMaxS49: "968f29e7-7f29-4da6-bd16-9f397f93d6ed",
        humidityAllowedMaxX49: "627eb18f-5d37-4a54-9102-534776dd2cda",
        humidityAllowedMaxS50: "114e5ad7-02dd-42dd-a371-5cc1000d07bd",
        humidityAllowedMaxX50: "e47200de-2eaa-4f03-9fd9-f1e23da84b32",
        humidityAllowedMaxS47: "cc45460b-5444-4296-b519-6f507ad27f72",
        humidityAllowedMaxX47: "2ced51d4-05c6-465d-a4fc-8da3182eaabb",
        humidityAllowedMaxS48: "dd355335-e3e9-4bab-a8b1-3978f43ce657",
        humidityAllowedMaxX48: "efa451c2-949b-4d64-8674-0a2c29e4fa6c",
        humidityAllowedMaxS45: "e56702cc-7fa5-42f7-9e6c-41115033bf20",
        humidityAllowedMaxX45: "12cc735c-3b98-4857-bea2-0706413b9c93",
        humidityAllowedMaxS46: "da290182-d6d4-4e35-9d6e-940905ffbb5f",
        humidityAllowedMaxX46: "1adc2e07-6869-42f4-b6db-54fe27c99349",
        humidityAllowedMaxDehumidifierLeft: "42e9d3e0-e6bb-4e99-a70a-84807a10db8b",
        humidityAllowedMaxDehumidifierRight: "7d31a969-65dd-4d8d-8466-6258bd6d97d5",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humiditySN3: "errorSN3",
        humiditySN26: "errorSN26",
        humidityS4: "errorS4",
        humidityS39: "errorS39",
        humidityS40: "errorS39",
        humidityS41: "errorS41",
        humidityS42: "errorS41",
        humidityS43: "errorS43",
        humidityS44: "errorS43",
        humidityS45: "errorS45",
        humidityS46: "errorS45",
        humidityS47: "errorS47",
        humidityS48: "errorS47",
        humidityS49: "errorS49",
        humidityS50: "errorS49",
        humidityS86: "errorS86",
        humiditySS3: "errorSS3",
        humiditySS21: "errorSS21",
        humidityXN3: "errorXN3",
        humidityXN26: "errorXN26",
        humidityX4: "errorX4",
        humidityX39: "errorX39",
        humidityX40: "errorX39",
        humidityX41: "errorX41",
        humidityX42: "errorX41",
        humidityX43: "errorX43",
        humidityX44: "errorX43",
        humidityX45: "errorX45",
        humidityX46: "errorX45",
        humidityX47: "errorX47",
        humidityX48: "errorX47",
        humidityX49: "errorX49",
        humidityX50: "errorX49",
        humidityX86: "errorX86",
        humidityXS21: "errorXS21",
        humidityXS3: "errorXS3",

        temperaturerSN3: "errorSN3",
        temperaturerSN26: "errorSN26",
        temperaturerS4: "errorS4",
        temperaturerS39: "errorS39",
        temperaturerS40: "errorS39",
        temperaturerS41: "errorS41",
        temperaturerS42: "errorS41",
        temperaturerS43: "errorS43",
        temperaturerS44: "errorS43",
        temperaturerS45: "errorS45",
        temperaturerS46: "errorS45",
        temperaturerS47: "errorS47",
        temperaturerS48: "errorS47",
        temperaturerS49: "errorS49",
        temperaturerS50: "errorS49",
        temperaturerS86: "errorS86",
        temperaturerSS3: "errorSS3",
        temperaturerSS21: "errorSS21",
        temperaturerXN3: "errorXN3",
        temperaturerXN26: "errorXN26",
        temperaturerX4: "errorX4",
        temperaturerX39: "errorX39",
        temperaturerX40: "errorX39",
        temperaturerX41: "errorX41",
        temperaturerX42: "errorX41",
        temperaturerX43: "errorX43",
        temperaturerX44: "errorX43",
        temperaturerX45: "errorX45",
        temperaturerX46: "errorX45",
        temperaturerX47: "errorX47",
        temperaturerX48: "errorX47",
        temperaturerX49: "errorX49",
        temperaturerX50: "errorX49",
        temperaturerX86: "errorX86",
        temperaturerXS21: "errorXS21",
        temperaturerXS3: "errorXS3",

        pressureSN3: "errorSN3",
        pressureSN26: "errorSN26",
        pressureS4: "errorS4",
        pressureS39: "errorS39",
        pressureS40: "errorS39",
        pressureS41: "errorS41",
        pressureS42: "errorS41",
        pressureS43: "errorS43",
        pressureS44: "errorS43",
        pressureS45: "errorS45",
        pressureS46: "errorS45",
        pressureS47: "errorS47",
        pressureS48: "errorS47",
        pressureS49: "errorS49",
        pressureS50: "errorS49",
        pressureS86: "errorS86",
        pressureSS3: "errorSS3",
        pressureSS21: "errorSS21",
        pressureXN3: "errorXN3",
        pressureXN26: "errorXN26",
        pressureX4: "errorX4",
        pressureX39: "errorX39",
        pressureX40: "errorX39",
        pressureX41: "errorX41",
        pressureX42: "errorX41",
        pressureX43: "errorX43",
        pressureX44: "errorX43",
        pressureX45: "errorX45",
        pressureX46: "errorX45",
        pressureX47: "errorX47",
        pressureX48: "errorX47",
        pressureX49: "errorX49",
        pressureX50: "errorX49",
        pressureX86: "errorX86",
        pressureXS21: "errorXS21",
        pressureXS3: "errorXS3",

        humidityDehumidifierLeft: "errorDehumidifierLeft",
        temperatureDehumidifierLeft: "errorDehumidifierLeft",
        humidityDehumidifierRight: "errorDehumidifierRight",
        temperatureDehumidifierRight: "errorDehumidifierRight",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierLeft: "errorDehumidifierLeft",
        malfunctionDehumidifierRight: "errorDehumidifierRight",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humiditySN3: "humidityTooltipErrorSN3",
        humiditySN26: "humidityTooltipErrorSN26",
        humidityS4: "humidityTooltipErrorS4",
        humidityS39: "humidityTooltipErrorS39",
        humidityS40: "humidityTooltipErrorS40",
        humidityS41: "humidityTooltipErrorS41",
        humidityS42: "humidityTooltipErrorS42",
        humidityS43: "humidityTooltipErrorS43",
        humidityS44: "humidityTooltipErrorS44",
        humidityS45: "humidityTooltipErrorS45",
        humidityS46: "humidityTooltipErrorS46",
        humidityS47: "humidityTooltipErrorS47",
        humidityS48: "humidityTooltipErrorS48",
        humidityS49: "humidityTooltipErrorS49",
        humidityS50: "humidityTooltipErrorS50",
        humidityS86: "humidityTooltipErrorS86",
        humiditySS3: "humidityTooltipErrorSS3",
        humiditySS21: "humidityTooltipErrorSS21",
        humidityXN3: "humidityTooltipErrorXN3",
        humidityXN26: "humidityTooltipErrorXN26",
        humidityX4: "humidityTooltipErrorX4",
        humidityX39: "humidityTooltipErrorX39",
        humidityX40: "humidityTooltipErrorX40",
        humidityX41: "humidityTooltipErrorX41",
        humidityX42: "humidityTooltipErrorX42",
        humidityX43: "humidityTooltipErrorX43",
        humidityX44: "humidityTooltipErrorX44",
        humidityX45: "humidityTooltipErrorX45",
        humidityX46: "humidityTooltipErrorX46",
        humidityX47: "humidityTooltipErrorX47",
        humidityX48: "humidityTooltipErrorX48",
        humidityX49: "humidityTooltipErrorX49",
        humidityX50: "humidityTooltipErrorX50",
        humidityX86: "humidityTooltipErrorX86",
        humidityXS21: "humidityTooltipErrorXS21",
        humidityXS3: "humidityTooltipErrorXS3",
        humidityDehumidifierLeft: "humidityTooltipErrorDehumidifierLeft",
        humidityDehumidifierRight: "humidityTooltipErrorDehumidifierRight",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierLeft: "runningClassLeft",
        runningDehumidifierRight: "runningClassRight",
      },

      //station id list
      stationIdList: [
        "a2c8bf9f-1281-4987-b35b-4bbfab942cb9",
        "7851c6a8-4304-4e34-b913-e8dfce2797f2",
        "236a0656-c054-4af8-9610-d654fd72630a",
        "f5dac257-4b54-4292-9cf7-36e733aa8f65",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          console.log("set data and error: " + dataName);

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
    hrefToScenario(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + "/dataHistory?bridgeId=" + this.bridgeId + "&scenarioId=" + id);
    },
    hrefToStation(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + id);
    },
  },
};
</script>
      
      <style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        font-weight: bold;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/xihoumen/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 122px;
          left: 173px;
        }

        .station-block-middle {
          top: 122px;
          left: 582px;
        }

        .station-block-right {
          top: 122px;
          left: 990px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 93%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 50%;
              top: -5px;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sensor-left-1 {
          top: 180px;
          left: 90px;
          &::before {
            bottom: 22px;
            left: -23px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -27px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-left-2 {
          top: 125px;
          left: 255px;
          &::before {
            bottom: 22px;
            left: -23px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -27px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-1 {
          top: 125px;
          left: 320px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -150px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-middle-2 {
          top: 173px;
          left: 545px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-3 {
          top: 175px;
          left: 575px;
          &::before {
            bottom: 34px;
            left: -31px;
            width: 50px;
            transform: rotate(65deg);
          }
          &::after {
            bottom: 57px;
            left: -31px;
          }
          .state-info {
            right: 45px;
            top: -41px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-4 {
          top: 180px;
          left: 626px;
          &::before {
            bottom: 40px;
            left: -22px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: -90px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-5 {
          top: 180px;
          left: 626px;
          &::before {
            bottom: -5px;
            left: -9px;
            width: 35px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: 70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-6 {
          top: 175px;
          left: 675px;
          &::before {
            bottom: 34px;
            left: -6px;
            width: 50px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 57px;
            left: 27px;
          }
          .state-info {
            right: -188px;
            top: -41px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-7 {
          top: 173px;
          left: 702px;
          &::before {
            bottom: -25px;
            left: -20px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 21px;
          }
          .state-info {
            right: -182px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 165px;
          }
        }

        .sensor-middle-8 {
          top: 125px;
          left: 918px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 38px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-right-2 {
          top: 125px;
          left: 983px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -150px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sensor-right-1 {
          top: 180px;
          left: 1123px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -150px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .station-block-left {
          top: 108px;
          left: 282px;
        }

        .sta-left {
          top: 108px;
          left: 282px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 115px;
          }
        }

        .station-block-right {
          top: 108px;
          left: 945px;
        }

        .sta-right {
          top: 108px;
          left: 945px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -70px;
            top: -70px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 115px;
          }
        }
      }
    }
  }
}
</style>